import { useAuth } from "../hooks/useAuth";
import { useProjects } from "../hooks/useProjects";
import { useModal } from "../hooks/useModal";
import { useNotifications } from "../hooks/useNotifications";
import ProjectCard from "../components/ProjectCard";
import "../styles/dashboard.css";

const Dashboard = () => {
  const { isAuthenticated } = useAuth();
  const {
    projects,
    createProject,
    removeProject,
    setSelectedProject,
  } = useProjects();
  const projectModal = useModal();
  const { success } = useNotifications();

  if (!isAuthenticated) {
    return (
      <div className="page-container">
        <h2>Please login first.</h2>
      </div>
    );
  }

  const handleOpenNew = () => {
    projectModal.open();
  };

  const handleCreateProject = (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const name = form.get("name");
    const description = form.get("description");
    createProject({ name, description });
    success("Project created");
    projectModal.close();
  };

  const handleDeleteProject = (id) => {
    removeProject(id);
    success("Project deleted");
  };

  const handleOpenProject = (projectId) => {
    setSelectedProject(projectId);
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Dashboard</h1>
        <button className="btn-primary" onClick={handleOpenNew}>
          + New Project
        </button>
      </div>

      <div className="projects-grid">
        {projects.map((p) => (
          <ProjectCard
            key={p.id}
            project={p}
            onDelete={(id) => {
              handleOpenProject(id);
              handleDeleteProject(id);
            }}
          />
        ))}
        {projects.length === 0 && (
          <div className="empty-text">No projects yet. Create your first!</div>
        )}
      </div>

      {projectModal.isOpen && (
        <div className="modal-overlay" onClick={projectModal.close}>
          <div
            className="modal-container small-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h2>Create Project</h2>
              <button
                className="modal-close"
                onClick={projectModal.close}
              >
                ✕
              </button>
            </div>
            <form onSubmit={handleCreateProject} className="modal-body">
              <label>
                Name
                <input name="name" required />
              </label>
              <label>
                Description
                <textarea name="description" />
              </label>
              <div className="modal-footer-right">
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={projectModal.close}
                >
                  Cancel
                </button>
                <button type="submit" className="btn-primary">
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
